var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleFonts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26L15.95 0H25.85V3.61739L12.1 26",
    fill: "#FBBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85 26H15.95V0H25.85V26Z",
    fill: "#1A73E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.6522C33 22.7104 29.799 26 25.85 26V11.3044C29.799 11.3044 33 14.5939 33 18.6522Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85 26C21.901 26 18.7 22.7104 18.7 18.6522C18.7 14.5939 21.901 11.3044 25.85 11.3044V26Z",
    fill: "#0D652D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.35 5.65217C31.35 8.7733 28.8882 11.3043 25.85 11.3043V0C28.8882 0 31.35 2.53104 31.35 5.65217Z",
    fill: "#1A73E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85 11.3043C22.8118 11.3043 20.35 8.7733 20.35 5.65217C20.35 2.53104 22.8118 0 25.85 0V11.3043Z",
    fill: "#174EA6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.549988 5.08696C0.549988 2.27783 2.76649 0 5.49999 0C8.23349 0 10.45 2.27783 10.45 5.08696C10.45 7.89609 8.23349 10.1739 5.49999 10.1739C2.76649 10.1739 0.549988 7.89609 0.549988 5.08696Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFonts);
export default __webpack_public_path__ + "static/media/GoogleFonts.41e77d5a2d4f9719ecd3114ed2fbe43a.svg";
export { ForwardRef as ReactComponent };